module.exports = __webpack_public_path__ + "static/media/vercel-en.bdebbc73.svg";